var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.threeDSecure)?_c('ThreeDSecure'):(_vm.redirect)?_c('RedirectPage'):(!_vm.authenticated)?_c('Login',{on:{"logged":function($event){return _vm.catchLogin($event)}}}):(_vm.appReady)?_c('Navbar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }